import { Box, Text } from "@chakra-ui/react";
import { isToday, isTomorrow, format } from "date-fns";
import { textStyle } from "theme/names";

interface Props {
  slots: { time: Date; slotsOfTheDay: any[] }[];
  render: (slotItem: { time: Date; tweet: any }) => React.ReactNode;
}

export function Timeline({ slots = [], render }: Props) {
  // console.log(slots);
  return (
    <Box>
      {slots.map((day, index) => (
        <Box mt={7} key={"day-" + index + "-" + day?.time?.getTime()}>
          <Text textStyle={textStyle["body.medium.light"]} pb={4} fontSize="lg" fontWeight="700">
            {isToday(day.time) ? "Today | " : ""}
            {isTomorrow(day.time) ? "Tomorrow | " : ""}
            {isToday(day.time) || isTomorrow(day.time)
              ? format(day.time, "MMMM dd")
              : format(day.time, "EEEE | MMMM dd")}
          </Text>
          {day?.slotsOfTheDay?.map(render)}
        </Box>
      ))}
    </Box>
  );
}
